import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

export default function RowBar({
  actions,
  additionalClasses,
  content,
  modifiers,
  onClick,
}) {
  return (
    <div
      className={classNames(
        'row-bar tw-border-grey-100 tw-bg-white',
        modifiers?.map((modifier) => `row-bar--${modifier}`).join(' '),
        additionalClasses,
      )}
      onClick={onClick}
    >
      <div className='row-bar__content'>{content}</div>
      <div className='row-bar__actions'>{actions}</div>
    </div>
  );
}

RowBar.propTypes = {
  modifiers: PropTypes.array,
  content: PropTypes.any,
  actions: PropTypes.any,
  additionalClasses: PropTypes.string,
  onClick: PropTypes.func,
};

RowBar.defaultProps = {
  actions: '',
  content: '',
};
